import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AdminService } from '../rest_services/admin.service';
import { ServiceResponse } from '../models/service-response';

@Component({
  selector: 'app-admin-space',
  templateUrl: './admin-space.component.html',
  styleUrls: ['./admin-space.component.css']
})
export class AdminSpaceComponent implements OnInit {

  loading_accounts:boolean=true;
  advancedSearchForm: FormGroup;
  accounts:any[]=[]
  accountsSubscription!: Subscription;

  constructor(
    private fb:FormBuilder,
    private adminService: AdminService
    ) { 
    this.advancedSearchForm = this.fb.group({
      'customer': [''],
      'commercial' : [''] ,
      'customer_sector' : [''] ,
      'visit_topic' : [''] ,
      'customer_city' : [''],
      'action_type' : [''],
      'action_status' : [''],
      'visit_action_status' : [''],
      'start_date':[''],
      'end_date':['']
    }); 
  }

  ngOnInit(): void {
    this.getAccounts();
  }

  onKeyUp(event:any,input:any) { // appending the updated value to the variable
    if(event.target.value.length==0) {
      this.advancedSearchForm.controls[input].setValue("");
    }
  }

  getAccounts(){
    this.accountsSubscription = this.adminService.getAccounts().subscribe(
      (data: ServiceResponse) => {
        if(data.code == "c4324208673f400ca28cca4fe14f93c9"){
          this.accounts = data.accounts?data.accounts:[];
          this.loading_accounts=false
        }    
      },
      (error: any) => {
        console.log(error);
      }
    );
  }
}
